export default __webpack_public_path__ + "static/media/ConsentText.58811e52.svg";